export function imgURL(url: string) {
  return `${process.env.NODE_ENV === "production" ? "/dj-static/assets/frontend" : ""}${url}`;
}

export const RENDER_BASE = process.env.NODE_ENV === "development" ? "http://localhost:8222/" : "/";